import { Divider, IconButton, Stack, Typography } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { CompanyRole } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../../../../components/button/CustomButton';
import CustomModal from '../../../../../../../components/modal/CustomModal';
import { secondaryBlue } from '../../../../../../../utils/color';
import useUserCompany from '../../../../../../../utils/hooks/useUserCompany';
import useMode from '../../../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../../../utils/context/Mode.context';

interface IAboutFinancingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutFinancingModal = ({ isOpen, onClose }: IAboutFinancingModalProps) => {
  const { mode } = useMode();
  const { t } = useTranslation();

  return (
    <CustomModal open={isOpen} onClose={onClose} sx={{ maxWidth: '770px', width: '100%' }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <IconButton
            sx={{
              borderRadius: '4px',
              bgcolor: 'secondaryBlue.100',
              width: '3rem',
              height: '3rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': { bgcolor: 'secondaryBlue.100' },
            }}
          >
            <AttachMoneyIcon sx={{ color: secondaryBlue[700] }} />
          </IconButton>
          <Typography variant="body2" fontWeight={600}>
            {mode === EnumMode.Client
              ? t('financing.aboutDeferredPayment')
              : t('financing.aboutPayment')}
          </Typography>
        </Stack>

        <Divider />
        {mode === EnumMode.Client ? (
          <Stack spacing={3}>
            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.headingClient')}
            </Typography>

            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.toStart')}{' '}
              <Typography
                component="span"
                variant="bodySemiBold2"
                sx={{ fontStyle: 'italic' }}
                color="primaryLight.700"
              >
                {t('financing.deferPayment')}
              </Typography>{' '}
              {t('financing.aboutModal.andThen')}{' '}
              <Typography
                component="span"
                variant="bodySemiBold2"
                sx={{ fontStyle: 'italic' }}
                color="primaryLight.700"
              >
                {t('financing.newRequest')}
              </Typography>
              . {t('financing.aboutModal.fillForm')}
            </Typography>
            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.ourTeamWillReview')}
            </Typography>
          </Stack>
        ) : (
          <Stack spacing={3} sx={{ paddingY: '1rem' }}>
            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.headingSupplier')}
            </Typography>

            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.toStart')}{' '}
              <Typography
                component="span"
                variant="bodySemiBold2"
                sx={{ fontStyle: 'italic' }}
                color="primaryLight.700"
              >
                {t('financing.getPaidNow')}{' '}
              </Typography>{' '}
              {t('financing.aboutModal.andThen')}{' '}
              <Typography
                component="span"
                variant="bodySemiBold2"
                sx={{ fontStyle: 'italic' }}
                color="primaryLight.700"
              >
                {t('financing.newRequest')}
              </Typography>
              . {t('financing.aboutModal.fillForm')}
            </Typography>
            <Typography variant="bodyMedium2" color="primaryDark.600">
              {t('financing.aboutModal.ourTeamWillReview')}
            </Typography>
          </Stack>
        )}
        <Divider />
        <Stack spacing={2} direction="row" justifyContent="flex-end">
          <CustomButton onClick={onClose}>{t('common.close')}</CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default AboutFinancingModal;
